import * as React from 'react';
import type { InjectedIntlProps, FormattedMessage } from 'react-intl';
import { Container } from './styled';
import { injectIntl } from 'react-intl';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

interface Props {
    errorMessage: string | FormattedMessage.MessageDescriptor;
}

const ErrorIndication: React.FunctionComponent<Props & InjectedIntlProps> = ({ errorMessage, intl }) => {
    return (
        <Container>
            <ErrorIcon size={'small'} label="error" primaryColor={token('color.icon.danger', colors.R500)} />
            {typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)}
        </Container>
    );
};

export default injectIntl(ErrorIndication);
